import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { RouterUrlParams } from 'App';
import { capitalizeWord } from '../../utils/helpers';
import { KnowledgeBase } from '../knowledgeBase/KnowledgeBase';

export const KnowledgeBasePage = () => {
	const { t } = useTranslation();

	const { programName } = useParams() as RouterUrlParams;
	const programTitle = programName ? capitalizeWord(programName) : undefined;

	return (
		<>
			<Helmet title={t('userPanel.files.header')} titleTemplate={`%s - ${programTitle} | Mentiway`} />
			<div className="h-full">
				<KnowledgeBase />
			</div>
		</>
	);
};
